'use client';

import React from 'react';

/**
 * Shared shell for custom recharts `<Tooltip content={...} />` renderers used
 * across Agent Insights charts. Handles the standard active/payload guard and
 * the bordered white card shell; callers supply the tooltip's own content.
 */
export function RechartsTooltipCard({
  active,
  payload,
  children,
}: {
  active?: boolean;
  payload?: unknown[];
  children: React.ReactNode;
}) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-ds-border-subtlest bg-ds-surface-white px-3 py-2 shadow-md">
      {children}
    </div>
  );
}
